import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    addedFemaleBeneficiary: `{name} has been added to the list of beneficial owners.`,
    addedMaleBeneficiary: `{name} has been added to the list of beneficial owners.`,
    deletedFemaleBeneficiary: `{name} has been deleted from the list of beneficial owners.`,
    deletedMaleBeneficiary: `{name} has been deleted from the list of beneficial owners.`,
    invitationSent: 'Invitation sent successfully !',
    updatedBeneficiary: `Information has been saved successfully`,
  },
  fr: {
    addedFemaleBeneficiary: `{name} a été ajoutée à la liste des bénéficiaires effectifs`,
    addedMaleBeneficiary: `{name} a été ajouté à la liste des bénéficiaires effectifs`,
    deletedFemaleBeneficiary: `{name} a été retirée de la liste des bénéficiaires effectifs`,
    deletedMaleBeneficiary: `{name} a été retiré de la liste des bénéficiaires effectifs`,
    invitationSent: 'Invitation envoyée avec succès !',
    updatedBeneficiary: `Informations enregistrées avec succès !`,
  },
} as const);
